var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 12.7246C14.2353 12.7246 16.25 10.7099 16.25 8.22461C16.25 5.73933 14.2353 3.72461 11.75 3.72461C9.26472 3.72461 7.25 5.73933 7.25 8.22461C7.25 10.7099 9.26472 12.7246 11.75 12.7246ZM11.75 23.9746C16.0992 23.9746 19.625 21.9599 19.625 19.4746C19.625 16.9893 16.0992 14.9746 11.75 14.9746C7.40076 14.9746 3.875 16.9893 3.875 19.4746C3.875 21.9599 7.40076 23.9746 11.75 23.9746ZM16.2066 12.517C17.2784 11.4044 17.9375 9.89154 17.9375 8.2247C17.9375 7.43203 17.7884 6.67417 17.5168 5.97763C19.315 6.052 20.7499 7.53328 20.7499 9.3497C20.7499 11.2137 19.2389 12.7247 17.3749 12.7247C16.9642 12.7247 16.5707 12.6513 16.2066 12.517ZM21.3124 19.4745C21.3124 20.0807 21.1777 20.6665 20.9266 21.2201C22.8463 20.625 24.1249 19.5619 24.1249 18.3495C24.1249 16.6551 21.6274 15.2522 18.3726 15.0111C20.1846 16.1371 21.3124 17.7206 21.3124 19.4745Z",
    fill: "#407BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers01);
export default __webpack_public_path__ + "static/media/users 01.030301423cf5405b68dd022a04885d76.svg";
export { ForwardRef as ReactComponent };